import React from "react";
import Routes from "./Routes";

function App() {
  return (
    <div className="overflow-hidden">
<Routes />
    </div>
    
  );
}

export default App;
